import { IExamInfo } from "../../../repositories/model/transfer/IExamInfo";


export interface PageInfo {
  page: number;
}
export type QuestionNameToPageInfo = Record<string, PageInfo>;

export default class PdfToQAMapper {

  public static readQuestionNameToPageIndex(
    examList: IExamInfo[]
  ): QuestionNameToPageInfo {
    
    const ret: QuestionNameToPageInfo = {};

    let pageIndex = 0;

    for (let examIndex = 0; examIndex < examList.length; examIndex++) {
      const questions = examList[examIndex].questions;

      for (let questionIndex = 0; questionIndex < questions.length; questionIndex++) {
        const questionText = `${examIndex + 1}-${questionIndex + 1}`;
        ret[questionText] = { page: pageIndex };
        pageIndex++;
      }
    }

    return ret;
  }
}